import { BaseProduct } from "Store/interfaces/products/checkPrice/BaseProduct";

export enum AccidentInsuranceType {
  ACCIDENT_DISABLEMENT = "accidentDisablement",
  ACCIDENT_DEATH = "accidentDeath",
}

export interface AccidentPriceRequestInfo extends BaseProduct {
  deathCoverageAmount: number;
  disabilityCoverageAmount: number;
  insuredOwnerAge?: string;
  isInsuredOwner: boolean;
}
